import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.map";
import React from 'react';
import SplashLink from './SplashLink';

function DesktopSplashCta(_ref) {
  var splashCTAButtons = _ref.splashCTAButtons;
  return splashCTAButtons && Array.isArray(splashCTAButtons) ? splashCTAButtons.map(function (_ref2, index) {
    var title = _ref2.title,
        splashUrl = _ref2.splash_link,
        primary = _ref2.primary;
    return splashUrl && title && /*#__PURE__*/React.createElement(SplashLink, {
      key: index,
      title: title,
      splashUrl: splashUrl,
      primary: primary
    });
  }) : null;
}

export default DesktopSplashCta;